import BaseFeature from '../../foundation/base/base';

class ModuleContentCardsFOU extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.list = this.el.querySelector('[data-ref="module-content-cards-fou__list"]');

		this.changeListSetup();
		this.addTopSpacing();
	}

	changeListSetup() {
		if (this.list.children.length > 1) {
			this.list.classList.add('o-module-content-cards-fou__list--grid');
		}
	}

	addTopSpacing() {
		if (this.list.children.length === 1) {
			this.el.classList.add('o-module-content-cards-fou--top-spacing');
		}
	}
}

export default ModuleContentCardsFOU;
